import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'

export type HeroBannerAboutUsProps = {
  herobannerheading: string
  herobannertitle: string
  herobannersmalltitle: string
}
export const HeroBannerAboutUs = ({ ...props }: HeroBannerAboutUsProps) => {
  const { palette } = useTheme()
  return (
    <Box
      sx={{
        mx: 'auto',
        pb: { laptop: 10 },
        pt:1
      }}>
      <Box component='section'
        sx={{
          overflowX: 'hidden',
          position: 'relative'
        }}>
        <Box
          sx={{
            maxWidth: 1152,
            pt: { xs: 6, laptop: 12 },
            px: 1.5,
            mx: 'auto',
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            textAlign: { tablet: 'center' },
            alignItems: { tablet: 'center' }
          }}>
          <Typography 
            sx={{
              textTransform: 'uppercase',
              fontSize: { tablet: 18 },
              fontWeight: 700,
              color: palette.secondary.main
            }}>
            {props?.herobannerheading}
          </Typography>
          <Typography 
            sx={{
              fontWeight:700,
              fontSize: { xs: 50, tablet: 64 },
            }}>
            {props?.herobannertitle}
          </Typography>
          <Typography variant='subtitle1'
            sx={{
              mt: 2,
              maxWidth: 832,
            }}>
            {props?.herobannersmalltitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
